import { render, staticRenderFns } from "./TiXian.vue?vue&type=template&id=328fe480&scoped=true&"
import script from "./TiXian.vue?vue&type=script&lang=js&"
export * from "./TiXian.vue?vue&type=script&lang=js&"
import style0 from "./TiXian.vue?vue&type=style&index=0&id=328fe480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328fe480",
  null
  
)

export default component.exports